import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const PayGroupService = {
  getAllPayGroup(obj) {
    return httpClient.post(endPoints.getPayGroup, obj);
  },
  updatePayGroup(obj) {
    return httpClient.post(endPoints.updatePayGroup, obj);
  },
  addPayGroup(obj) {
    return httpClient.post(endPoints.addPayGroup, obj);
  },
  deletePayGroup(obj) {
    return httpClient.post(endPoints.deletePayGroup, obj);
  },
};

export default PayGroupService;



// WEBPACK FOOTER //
// ./src/service/PayGroupService.js